import Amplitude from 'utils/amplitude';
import appsFlyer from 'utils/packages/rnAppsflyer';
import { logAnalyticsEvent } from 'utils/packages/rnFirebase';
export const logBankAdded = async (connectingBank, crypto) => {
    if (crypto) {
        Amplitude.logEvent('Bank Added');
    }
    else {
        Amplitude.logEvent('OnBoarding.BankAdded', {
            bankName: connectingBank,
            isLogged: true,
        });
    }
    logAnalyticsEvent('Bank_Connections_Logged_In');
    try {
        await appsFlyer.logEvent('Bank Connections Logged In', {});
    }
    catch {
        //
    }
};
export const logBankAddedAtLogin = async (connectingBank) => {
    Amplitude.logEvent('OnBoarding.BankAdded', {
        bankName: connectingBank,
        isLogged: false,
    });
    logAnalyticsEvent('Onboarding_BankAdded');
    try {
        await appsFlyer.logEvent('Bank Connections At Login', {});
    }
    catch {
        // No op
    }
};
